import { useState } from 'react';
import axios from 'axios';
import { deleteCollectionorderApi } from '@/api/collectionOrder';

interface UseDeleteCollectionOrderResult {
  loading: boolean;
  error: string | null;
  deleteCollectionOrder: (id: string) => Promise<void>;
}

export function useDeleteCollectionOrder(): UseDeleteCollectionOrderResult {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const deleteCollectionOrder = async (id: string) => {
    setLoading(true);
    setError(null);

    try {
      // Assuming the API endpoint to delete a collection order is `/api/collectionOrders/{id}`
      await deleteCollectionorderApi(id);

      // Handle success (optional: trigger a refetch, show a success message, etc.)
    } catch (err) {
      setError('Failed to delete the collection order.');
    } finally {
      setLoading(false);
    }
  };

  return { loading, error, deleteCollectionOrder };
}
